import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Pill } from '@andes/badge';
import get from 'lodash/get';
import useTrackView from '../../hooks/use-track-view';
import { trackEvent } from '../../lib/tracking';
import StyledLabel from '../styled-label';
import MediaAction from '../media/media-action';
import { validateSnackbarColor } from '../../utils/validators';

const namespace = 'ui-vip-quoter-motors';

const QuoterMotors = ({ header, badge, extra_info, footer, show_track }) => {
  const footerComponent = get(footer, '[0].action');
  const extraInfoComponent = get(extra_info, '[0]');
  const track = get(footerComponent, 'track');

  // Thresholds are defined to know when te component is usable
  const refQuoterMotors = useTrackView(show_track, { threshold: 0.2 });

  return (
    <div ref={refQuoterMotors} className={namespace}>
      <StyledLabel {...header} className={`${namespace}__title`} as="h2" />

      {badge && (
        <Pill
          className={`${namespace}__feature__tag`}
          color={validateSnackbarColor(badge.type.toLowerCase())}
          size={badge.font_size.toLowerCase()}
          hierarchy={badge.hierarchy.toLowerCase()}
          roundedCorners={['top-right', 'top-left', 'bottom-right', 'bottom-left']}
        >
          {badge.text}
        </Pill>
      )}

      {extraInfoComponent && <span className={`${namespace}__text`}> {extraInfoComponent.text} </span>}

      {footerComponent && (
        <MediaAction
          className={`${namespace}__action`}
          label={footerComponent.label}
          target={footerComponent.target}
          htmlTarget={footerComponent.html_target}
          onClick={() => trackEvent(track)}
        />
      )}
    </div>
  );
};

QuoterMotors.propTypes = {
  header: shape({
    text: string,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  extra_info: arrayOf(
    shape({
      text: string,
    }),
  ).isRequired,
  badge: shape({
    text: string,
    color: string,
    bg_color: string,
    font_size: string,
    font_family: string,
    type: string,
    hierarchy: string,
    border: string,
  }),
  footer: arrayOf(
    shape({
      label: shape({
        text: string,
      }),
      target: string,
      html_target: string,
    }),
  ).isRequired,
  show_track: shape({}),
};

QuoterMotors.defaultProps = {
  show_track: null,
  badge: null,
};

export default React.memo(QuoterMotors);
